<template>
    <div class="flex">
        <div class="flex-1 pr-1">
            <label for="first_name" class="sr-only">First Name</label>
            <input :value="firstName" @change="$emit('update:first_name', $event.target.value)" type="text" name="first_name" id="first_name" :class="`bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`" placeholder="First Name">
        </div>
        <div class="flex-1 pl-1">
            <label for="last_name" class="sr-only">Last Name</label>
            <input :value="lastName" @change="$emit('update:last_name', $event.target.value)" type="text" name="last_name" id="last_name" :class="`bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`" placeholder="Last Name">
        </div>
    </div>
</template>

<script>
    export default {
        props: ['first_name', 'last_name'],

        computed: {
            firstName() {
                return this.first_name;
            },

            lastName() {
                return this.last_name;
            }
        }
    }
</script>